import { useState } from "react";
import PhoneInput from "react-phone-input-2";
import {
  Button,
  Dropdown,
  Form,
  Icon,
  Input,
  Modal,
  Select,
} from "semantic-ui-react";
import { updateGuestProfile } from "services/bookings";
import { getBookingByConfirmationNumber } from "services/hotels";
import { getWechatQrCode } from "services/notifications";
import { createRoomReady, updateRoomReady } from "services/roomReadys";

const noError = {
  search: "",
  bookingNumber: "",
  firstName: "",
  lastName: "",
  email: "",
  language: "",
  phoneNumber: "",
  notificationMethodIds: "",
};
export default function AddOrEditWaitForRoomPopup(props: any): JSX.Element {
  const {
    popup,
    setPopup,
    setBookingFilter,
    roomReady = {},
    setRoomReady,
    notificationMethods,
    fetchCount,
    setFetchCount,
    hotel,
    setQrCode,
  } = props;
  const { isNew } = roomReady;
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(noError);

  const createOrUpdateRoomReady = async (isNew: boolean) => {
    try {
      if (!roomReady.email) delete roomReady.email;
      if (!roomReady.phoneNumber || roomReady.phoneNumber === "+852")
        delete roomReady.phoneNumber;

      if (isNew) {
        // console.log('new')
        const { notificationMethodIds } = roomReady;
        const wechatMethod = notificationMethods?.find(
          (method: any) => method.textEN === "WeChat"
        );
        const hasWeChat = !!notificationMethodIds?.find(
          (code: string) => code === wechatMethod?.code
        );
        if (hasWeChat) {
          const qrcode = await getWechatQrCode(
            roomReady.bookingNumber,
            roomReady.language
          );
          setQrCode(qrcode);
        }

        await createRoomReady({ ...roomReady });
        setPopup({ ...popup, wechatQrcode: hasWeChat, addWaitForRoom: false });
      } else {
        // console.log('update')
        /* update mongo */
        await updateRoomReady({
          ...JSON.parse(
            JSON.stringify({
              ...roomReady,
              profile: {
                ...roomReady?.profile,
                email: { email: roomReady.email || "" },
                phoneNumber: { number: roomReady.phoneNumber || "" },
              },
            })
              .replace("(", "")
              .replace(")", "")
          ),
          hotelId: hotel.id,
        });
        setPopup({ ...popup, addWaitForRoom: false });
      }

      setError({ ...noError });
      setFetchCount(fetchCount + 1);
    } catch (err: any) {
      console.log(err.message);
      setError({ ...error, search: err.message });
    }
  };

  return (
    <Modal
      size="tiny"
      onClose={() => setPopup({ ...popup, edit: false })}
      open={popup.addWaitForRoom}
    >
      <Modal.Header className="text-left">
        <div>
          <span>{isNew ? "Create" : "Edit"} wait for room</span>
        </div>
      </Modal.Header>
      <Modal.Content className="text-left">
        {error.search ? (
          <div style={{ color: "red", textAlign: "center" }}>
            {error.search}
          </div>
        ) : (
          ""
        )}
        <Form>
          <Form.Group>
            <Form.Input
              width={8}
              label="Booking Number"
              error={!!error.search || !!error.bookingNumber}
              fluid
              name="bookingNumber"
              placeholder="Booking Number"
              value={roomReady.bookingNumber}
              onChange={(e, data) =>
                isNew && setRoomReady({ ...roomReady, [data.name]: data.value })
              }
            />
            {isNew ? (
              <div style={{ marginTop: "auto" }}>
                <Form.Button
                  icon="search"
                  loading={loading}
                  disabled={loading}
                  content="Search"
                  onClick={async () => {
                    try {
                      setLoading(true);
                      const booking = await getBookingByConfirmationNumber(
                        roomReady.bookingNumber
                      );
                      const phoneNumber =
                        booking.profile?.phoneNumber?.number[0] !== "+"
                          ? `+852${booking.profile?.phoneNumber?.number}`
                          : booking.profile?.phoneNumber?.number;
                      setRoomReady({
                        ...roomReady,
                        email: booking.profile?.email?.email,
                        phoneNumber,
                        bookingNumber: booking.confirmationNumber,
                        firstName: booking.profile?.firstName,
                        lastName: booking.profile?.lastName,
                        profile: booking.profile,
                      });
                      // console.log({ booking })
                      setError({ ...error, search: "" });
                      setLoading(false);
                    } catch (err) {
                      setError({ ...error, search: "Booking not found" });
                      setLoading(false);
                    }
                  }}
                />
              </div>
            ) : (
              <></>
            )}
          </Form.Group>

          <Form.Group widths="equal">
            <Form.Input
              label="First Name"
              error={!!error.firstName}
              fluid
              name="firstName"
              placeholder="First Name"
              value={roomReady.firstName}
              onChange={(e, data) =>
                isNew && setRoomReady({ ...roomReady, [data.name]: data.value })
              }
            />
            <Form.Input
              label="Last Name"
              error={!!error.lastName}
              fluid
              name="lastName"
              placeholder="Last Name"
              value={roomReady.lastName}
              onChange={(e, data) =>
                isNew && setRoomReady({ ...roomReady, [data.name]: data.value })
              }
            />
          </Form.Group>

          <Form.Group widths="equal">
            <Form.Input
              label="Email"
              error={!!error.email}
              name="email"
              placeholder="New Email"
              value={roomReady.email}
              onChange={(e, data) =>
                setRoomReady({ ...roomReady, [data.name]: data.value })
              }
            />

            <Form.Select
              name="language"
              error={!!error.language}
              label="Language"
              placeholder="Language"
              value={roomReady.language}
              options={[
                { key: "en", value: "en", text: "English" },
                { key: "tc", value: "tc", text: "Traditional Chinese" },
                { key: "sc", value: "sc", text: "Simplified Chinese" },
              ]}
              onChange={(e, data) =>
                setRoomReady({ ...roomReady, [data.name]: data.value })
              }
            />
          </Form.Group>
        </Form>
        <div style={{ display: "flex", gap: "1.4rem" }}>
          <div>
            <label style={{ fontWeight: "600" }}>Phone (Whatsapp)</label>{" "}
            {error.phoneNumber ? (
              <span style={{ color: "red" }}> {error.phoneNumber}</span>
            ) : (
              <></>
            )}
            <PhoneInput
              inputStyle={{ width: "17rem" }}
              country={"hk"}
              value={
                roomReady?.phoneNumber?.[0] !== "+"
                  ? `+852${roomReady?.phoneNumber}`
                  : roomReady?.phoneNumber
              }
              onChange={(phone) =>
                setRoomReady({
                  ...roomReady,
                  phoneNumber: !phone ? "" : `+${phone}`,
                })
              }
            />
          </div>

          <div style={{ width: "100%" }}>
            <label style={{ fontWeight: "600" }}>Notification methods</label>{" "}
            {error.notificationMethodIds ? (
              <span style={{ color: "red" }}>
                {" "}
                {error.notificationMethodIds}
              </span>
            ) : (
              <></>
            )}
            <Dropdown
              name="notificationMethodIds"
              placeholder="Select Notification Methods"
              fluid
              multiple
              selection
              options={notificationMethods.map((method: any) => ({
                key: method.code,
                value: method.code,
                text: method.textEN,
              }))}
              onChange={(e: any, data: any) => {
                const { name, value } = data;
                // console.log(name, value)
                setRoomReady({ ...roomReady, [name]: value });
              }}
            />
          </div>
        </div>
      </Modal.Content>
      <Modal.Actions>
        <Button
          color="black"
          onClick={() => {
            setPopup({
              ...popup,
              addWaitForRoom: false,
            });
          }}
        >
          Close
        </Button>
        <Button
          // disabled={Object.values(error).some(err => !!err)}
          content={isNew ? "Create" : "Update"}
          icon="plus"
          onClick={async () => {
            // console.log({ roomReady })
            setError(() => ({ ...noError }));
            const checkErrors = Object.keys(error).reduce(
              (acc: any, key: string) => {
                if (key === "search") return acc;

                acc["phoneNumber"] = "";
                acc["email"] = "";
                if (!roomReady["phoneNumber"] && !roomReady["email"])
                  acc["search"] = "please enter either email or phone";

                if (
                  Array.isArray(roomReady[key]) &&
                  roomReady[key].length === 0
                )
                  acc[key] = "required";
                else if (!roomReady[key]) acc[key] = "required";
                else acc[key] = "";

                return acc;
              },
              {}
            );

            const hasMissing = Object.values(checkErrors).some((err) => !!err);

            // console.log(checkErrors)
            if (hasMissing) {
              setError({ ...checkErrors });
              return;
            }

            await createOrUpdateRoomReady(isNew);
          }}
          color="yellow"
        />
      </Modal.Actions>
    </Modal>
  );
}
